<div class="header-tools">
  <button (click)="navigateToOtherComponent(['tools'])">
    Go to Tools Page
  </button>
  <ng-content></ng-content>
  <button (click)="refreshJmkw()">Refresh JMKW</button>
</div>
